module.exports = __webpack_public_path__ + "img/import.d0f152d8.svg";